/* ══════════════════════════════════════════════════════════════════════
   AUTHOR SERVICES — vanilla port of the handoff's DCLogic class.
   Same behaviour, no framework. Everything is scoped to .tws-asvc so the
   locked chrome and footer are never touched.
   The handoff's scroll-progress rail lived in its own header, which this
   page does not use (the locked TWS header replaces it), so _initScrollFX
   keeps only the parallax half.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  /* Each Shopify section emits its own <script src="tws-asvc.js">, so this file
     runs once per section on the theme and once on the local page. Everything
     below must happen exactly once. */
  if (window.__twsAsvcInit) return;
  window.__twsAsvcInit = true;

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- headline type: every word rises out of its own mask ---- */
  function splitWords() {
    var heads = $$('.tws-asvc h1, .tws-asvc h2');
    var wrap = function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'sw';
            var i = document.createElement('i'); i.textContent = p;
            s.appendChild(i); frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' &&
                   n.tagName !== 'BUTTON' && n.tagName !== 'A') { wrap(n); }
      });
    };
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 52) + 'ms'; });
      };
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ---- the section rules draw themselves in ---- */
  function initRules() {
    var rules = $$('.tws-asvc .rule');
    if (!rules.length) return;
    var show = function (el) { el.style.animation = 'ruleIn .9s cubic-bezier(.22,.7,.25,1) both'; };
    if (REDUCE || typeof IntersectionObserver === 'undefined') { rules.forEach(show); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target); io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    rules.forEach(function (r) { io.observe(r); });
    /* backstop: a rule left at scaleX(0) is an invisible divider, so sweep too */
    var sweep = function () {
      var left = 0;
      rules.forEach(function (r) {
        if (r.style.animation) return;
        left++;
        if (r.getBoundingClientRect().top < innerHeight * 0.94) show(r);
      });
      if (!left) clearInterval(t);
    };
    var t = setInterval(sweep, 300);
    sweep();
  }

  /* ---- reveals: only what starts below the fold is hidden ---- */
  function initReveal() {
    if (REDUCE) return;                       // never leave content hidden
    var els = $$('.tws-asvc [data-rv]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var kind = el.getAttribute('data-rv') || 'rise';
        var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
        el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    var pending = [];
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight * 0.88) {
        el.style.opacity = '0'; io.observe(el); pending.push(el);
      }
    });

    /* ── the backstop ──
       Everything above is hidden by JS, and an IntersectionObserver alone must
       never be the only route back: anything that stops those callbacks — a
       throttled tab, an editor iframe, a stale script — would leave the page
       showing the hero and nothing else. This sweep reveals whatever is
       already on screen and can never leave content stranded. */
    var show = function (el) {
      var kind = el.getAttribute('data-rv') || 'rise';
      var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
      el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
      el.style.opacity = '';
    };
    var sweep = function () {
      for (var i = pending.length - 1; i >= 0; i--) {
        var el = pending[i];
        if (el.style.opacity !== '0') { pending.splice(i, 1); continue; }
        if (el.getBoundingClientRect().top < innerHeight * 0.94) { show(el); pending.splice(i, 1); }
      }
      if (!pending.length && timer) { clearInterval(timer); timer = null; }
    };
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    var timer = setInterval(sweep, 300);
    sweep();
  }

  /* ---- the hero object's parallax ---- */
  function initScrollFX() {
    var pars = $$('.tws-asvc [data-par]');
    if (!pars.length) return;
    var apply = function () {
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > innerHeight + 240) return;
        var c = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        var amt = parseFloat(el.getAttribute('data-par')) || 0;
        el.style.setProperty('--py', (-c * amt * 100).toFixed(1) + 'px');
      });
    };
    var queued = false;
    var run = function () { queued = false; try { apply(); } catch (e) {} };
    var onScroll = function () { if (queued) return; queued = true; requestAnimationFrame(run); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(run, 260);
    run();
  }

  /* ---- FAQ: one open at a time ---- */
  function initPanels() {
    var panels = $$('.tws-asvc details.cx');
    panels.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        panels.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function boot() { splitWords(); initReveal(); initRules(); initScrollFX(); initPanels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
